import { createStore } from "jotai";

// Create and export a single store instance to be used throughout the app
export const appStore = createStore();
